import PropTypes from 'prop-types';

import { FormattedMessage } from '@zenbusiness/application-commons-intl';
import Text from '@zenbusiness/zui/Text';

import { stateMap } from '#client/components/VeloAIAssistant/constants';

import * as Styled from '../OrderView.styles';

const LOCALIZED_TEXT = {
  domain: 'orderView.items.domain',
  jurisdiction: 'orderView.items.jurisdiction',
  amendmentOrdered: 'orderView.items.amendmentOrdered',
  worryFreeOrdered: 'orderView.items.worryFreeOrdered'
};

const GetProductDescription = ({ orderTaskType: type = '', orderTaskData: data }) => {
  if (type.includes('domain_name_reg')) {
    return (
      <Styled.ProductDescriptionRoot>
        <Text><FormattedMessage id={LOCALIZED_TEXT.domain} /></Text>
        <Text>{data.primary}</Text>
      </Styled.ProductDescriptionRoot>
    );
  }
  if (type.includes('annual_report') || type.includes('standard_good_standing')) {
    return (
      <Styled.ProductDescriptionRoot>
        <Text><FormattedMessage id={LOCALIZED_TEXT.jurisdiction} /></Text>
        <Text>{stateMap[data.jurisdiction || data.domesticJurisdiction]}</Text>
      </Styled.ProductDescriptionRoot>
    );
  }
  if (type.includes('_amendment')) {
    return (
      <Text>
        {data?.amendmentDescription || (
          <FormattedMessage id={LOCALIZED_TEXT.amendmentOrdered} />
        )}
      </Text>
    );
  }
  if (type === 'basic_email') {
    return <Text>{data?.fullEmailAddress}</Text>;
  }
  if (type.includes('worry_free_service')) {
    return <Text><FormattedMessage id={LOCALIZED_TEXT.worryFreeOrdered} /></Text>;
  }
  if (type.includes('future_file_date')) {
    return <Text>{data?.futureFilingDate}</Text>;
  }
  return null;
};

GetProductDescription.propTypes = {
  orderTaskType: PropTypes.string.isRequired,
  orderTaskData: PropTypes.shape({
    jurisdiction: PropTypes.string,
    domesticJurisdiction: PropTypes.string,
    amendmentDescription: PropTypes.string,
    fullEmailAddress: PropTypes.string,
    futureFilingDate: PropTypes.string,
    primary: PropTypes.string
  }).isRequired
};

export default GetProductDescription;
